import React from "react";

type P_Props = {};

const ComingSoonPresenter = (props: P_Props) => {
  return <div>Coming soon</div>;
};

export default ComingSoonPresenter;
